import React from 'react';
import './body.css';
//import Home from '../../views/home/Home';
import Pedidos from '../../views/pedido/Pedidos';
import CadPedido from '../../views/pedido/Pedido';
import AgenteModule from '../../views/agente/Agentes';
import { Agente } from '../../dto/Agentes';
import { DadosPedido as PedidoDto } from '../../dto/Pedidos';
import CadAgente from '../../views/agente/Agente';
import { ModoBarra } from '../../components/utils';
import CadEmpresa from '../../views/empresa/Empresa';
import EmpresaModule from '../../views/empresa/Empresas';
import { Empresa } from '../../dto/Empresa';
import HomeAdm from '../../views/home/HomeAdm';
import { Usuario } from '../../dto/Usuario';
import UsuarioModule from '../../views/usuario/Usuarios';
import CadUsuario from '../../views/usuario/Usuario';
import IndicadoresGraficos from '../../views/indicadores/IndicadoresGraficos';
//import NovoPedido from '../../views/pedido/novoPedido/novoPedido';
//import EditarPedido from '../../views/pedido/editarPedido/EditarPedido';

function Body(props: { view: string, agenteState?: Agente, pedidoState?: PedidoDto, empresaState?: Empresa, usuarioState?: Usuario }) {

  return (
    <>
      <div className='Body'>
       {/*  {props.view === 'home' && <Home />} */}
        {props.view === 'homeAdm' && <HomeAdm />}
        {props.view === 'pedido' && <Pedidos />}

        {props.view === 'agente' && <AgenteModule />}
        {props.view === 'cadAgente' && <CadAgente modoInicial={ModoBarra.novoregistro} />}

        {props.view === 'visualizarAgente' && <CadAgente modoInicial={ModoBarra.leitura} agenteSelecionado={props.agenteState} />}
        {props.view === 'editarAgente' && <CadAgente modoInicial={ModoBarra.edicao} agenteSelecionado={props.agenteState} />}

        {/*{props.view ==='visualizarPedido' && <EditarPedidoV2 pedido={props.pedidoState!} />}*/}
        {/*{props.view ==='editarAgente' && <EditarAgenteV2 agente={props.agenteState!} />}*/}
        {props.view === 'visualizarPedido' && <CadPedido modoInicial={ModoBarra.leitura} pedidoSelecionado={props.pedidoState!} />}
        {props.view === 'novoPedido' && <CadPedido modoInicial={ModoBarra.novoregistro} />}
        {props.view === 'editarPedido' && <CadPedido modoInicial={ModoBarra.edicao} pedidoSelecionado={props.pedidoState!} />}

        {/*  {props.view === 'homeAdm' && <HomeAdm />} */}
        {props.view === 'empresas' && <EmpresaModule />}
        {props.view === 'cadEmpresa' && <CadEmpresa modoInicial={ModoBarra.novoregistro} />}
        {props.view === 'visualizarEmpresa' && <CadEmpresa modoInicial={ModoBarra.leitura} empresaSelecionada={props.empresaState} />}
        {props.view === 'editarEmpresa' && <CadEmpresa modoInicial={ModoBarra.edicao} empresaSelecionada={props.empresaState!} />}

        {props.view === 'usuarios' && <UsuarioModule />}
        {props.view === 'cadUsuario' && <CadUsuario modoInicial={ModoBarra.novoregistro} />}
        {props.view === 'visualizarUsuario' && <CadUsuario modoInicial={ModoBarra.leitura} usuarioSelecionado={props.usuarioState} />}
        {props.view === 'editarUsuario' && <CadUsuario modoInicial={ModoBarra.edicao} usuarioSelecionado={props.usuarioState} />}
        {props.view === 'indicadoresGraficos' && <IndicadoresGraficos />}

      </div>
    </>
  );
}

export default Body;
